import { Optional } from '../../../types.js';
import { getTextSize } from '../../../visualizations/common/getTextSize.js';
import { bounds } from '../types.js';
import { legendsConfiguration } from './types.js';
export const calculateLegendBounds = (configuration: legendsConfiguration, names: string[], fitWidth: number): Optional<{
  bottom: number;
  height: number;
}> => {
  const positions: bounds[] = [];
  const {
    legendsOffsetTop,
    legendsOffsetLeft,
    legendsHorizontalGap,
    legendsVerticalGap,
    legendsColumnCount
  } = configuration;
  let top = legendsOffsetTop;
  let left = legendsOffsetLeft;
  for (let i = 0; i < names.length; i++) {
    const name = names[i];
    const {
      width,
      height
    } = getLegendSize(configuration, name, legendsColumnCount > 0 ? (fitWidth - legendsOffsetLeft) / legendsColumnCount - legendsColumnCount : undefined);
    const right = left + width;
    if (i === 0 || right < fitWidth) {
      positions.push({
        top,
        left,
        bottom: top + height,
        right
      });
      left += width + legendsHorizontalGap;
    } else {
      left = legendsOffsetLeft;
      top += height + legendsVerticalGap;
      positions.push({
        top,
        left,
        bottom: top + height,
        right
      });
      left += width + legendsHorizontalGap;
    }
  }
  if (!positions.length) {
    return undefined;
  }
  return {
    bottom: positions[positions.length - 1].bottom,
    height: positions[positions.length - 1].bottom - positions[0].top
  };
};
const getLegendSize = (configuration: legendsConfiguration, name: string, maxWidth?: number) => {
  const {
    legendIcon,
    legendName
  } = configuration;
  const textWidth = getTextSize(name, legendName.typography).width;
  const legendWidth = legendIcon.width + legendName.offsetLeft + textWidth;
  const legendHeight = legendIcon.height;
  return {
    width: maxWidth ? Math.min(maxWidth, legendWidth) : legendWidth,
    height: legendHeight
  };
};